import React from 'react';
import styles from '../css/comuns/FaixaPlanos.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { config } from '../../data';

const FaixaPlanos = () => {
  const navegarParaPlanoPersonalizado = () => {
    window.location.href = config.links.routes.monteSeuPlano;
  };

  return (
    <div className="container">
      <div className={styles['faixa']}>
        <div className={styles['particulas']}>
          <div className={styles['bolinha']}></div>
          <div className={styles['bolinha']}></div>
          <div className={styles['bolinha']}></div>
          <div className={styles['bolinha']}></div>
          <div className={styles['bolinha']}></div>
        </div>
        <div className="container">
          <div className={styles['conteudo']}>
            <p className={styles['texto']}>
              <span className={styles['destaque']}>{config.texts.faixaPlanos.texto}</span>
              {config.texts.faixaPlanos.subtexto}
            </p>
            <button 
              className={styles['botao']} 
              onClick={navegarParaPlanoPersonalizado}
            >
              <FontAwesomeIcon icon={faSlidersH} />
              {config.texts.faixaPlanos.botao}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaixaPlanos;